import { array } from 'fp-ts';
import { __, isArray, isEmpty, isFunction, isNil, isNumber, isPlainObject, isString, map } from 'lodash/fp';
import { Identifiable } from './interfaces';
import { keyById } from './keyBy';

const predicates = [isArray, isEmpty, isFunction, isNil, isNumber, isPlainObject, isString];

export const applyPredicates = map(__, predicates);
export const notNil = <T>(value: T): value is NonNullable<T> => value != null;

export const convertIntoRecord = <E extends Identifiable<string>>(entity: Array<E> | null | undefined) =>
    entity && array.isNonEmpty(entity) ? keyById(entity) : undefined;
